import React from "react";
import { FinalOutputButtonsBar } from "./FinalOutputButtonsBar/FinalOutputButtonsBar.logic";
import { FinalOutputList } from "./FinalOutputList/FinalOutputList.logic";
import "./FinalOutputList/Styles.scss";

/**
 * Responsible to render Final Output List
 * @returns Final Output view
 */
export const FinalOutputView: React.FC = () => {
  return (
    <div
      className="ebt-finaloutput-container"
      id="ebt-outputConfig-finalOutput-container"
    >
      <FinalOutputButtonsBar />
      <FinalOutputList />
    </div>
  );
};
